import React from 'react'

const IndicatorDot = ({ active, textIndicator = false, className = '' }) => {
  if (textIndicator) {
    const statusClassName = `text-${active ? 'success' : 'danger'}`
    const statusText = active ? 'Active' : 'Inactive'

    return <span className={statusClassName}>{statusText}</span>
  }

  return (
    <span
      className={`${className || 'active-indicator'} ${active ? 'active' : ''}`}
    />
  )
}

export default IndicatorDot
